// This function safely converts a value into a number
const GetSafeCurrencyNumber = (value) => {

    // Convert the supplied value into a number
    const numberValue = Number(value);

    // Return zero when the supplied value is not numeric
    if (!Number.isFinite(numberValue)) { return 0; }

    // Return the numeric value
    return numberValue;

};



// This function formats a currency value using the supplied currency code
export const FormatCurrency = (currencyCode, value, formatFromPennies = false) => {

    
    // Convert the supplied value into a safe number
    const numberValue = GetSafeCurrencyNumber(value);

    // Convert pence/cents into major currency units when requested
    const currencyValue = formatFromPennies ? numberValue / 100 : numberValue;

    // Store the supported currency symbols
    const currencySymbols = {
        GBP: "£",
        USD: "$",
        EUR: "€"
    };

    // Get the symbol for the supplied currency code
    const currencySymbol = currencySymbols[currencyCode];

    // Get the sign for negative values
    const sign = currencyValue < 0 ? "-" : "";

    // Get the absolute value so the minus sign appears before the currency symbol
    const absoluteCurrencyValue = Math.abs(currencyValue);

    // Return the formatted value using the supported currency symbol
    return `${sign}${currencySymbol}${absoluteCurrencyValue.toFixed(2)}`;

};



// This function converts an amount in pence to a formatted currency string
export const ConvertToCurrency = (currencyCode, amount) => {

    // Format the amount from pence/cents using the supplied currency code
    return FormatCurrency(currencyCode, amount, true);

};



// This function converts an amount in pence to a formatted GBP currency string
export const ConvertToCurrencyGBP = (amount) => {

    // Keep the old helper available for any older code that has not been updated yet
    return ConvertToCurrency("GBP", amount);

};



// Function to convert number value to two decimal places (ie.e order shipping costs where api return is e.g. 12.5)
export const FormatToTwoDecimalPlacesString = (value) => {

    // Convert the supplied value into a number
    const num = parseFloat(value);

    // Return a two decimal place string when the value is numeric
    return isNaN(num) ? "" : num.toFixed(2);

};